
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Doughnut } from 'vue-chartjs/legacy';
import { Getter } from "vuex-class";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
import Base from "@/shared/core/components/Base.vue";
import { CompleteStats } from "../../model/statistics/CompleteStats";
import { ChartData } from '../../model/statistics/ChartData';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

@Component({
  components: { Doughnut }
})
export default class LiveBookingsDoughnut extends Base {

  @Prop({ default: 'doughnut-chart' }) chartId!: string;

  @Prop({ default: 'label' }) datasetIdKey!: string;

  @Prop({ default: 190 }) width!: number;

  @Prop({ default: 170 }) height!: number;

  @Prop({ default: '' }) cssClasses!: string;

  @Prop() styles!: unknown;

  @Prop() plugins!: unknown[];

  @Prop({ default: 0 }) selectedSlotIndex!: number;

  @Prop({ default: "Aujourd'hui" }) selectedStatPeriod!: string;

  @Getter('bookingStatistics', { namespace: 'booking' }) bookingStatistics!: CompleteStats;

  @Watch("$store.state.booking.bookingStatistics.today.p1")
  handleStatsChange() {
    this.handleChartData()
  }

  @Watch("selectedSlotIndex")
  handleSlotIndexChange() {
    this.handleChartData()
  }

  chartBackgroundColor = ['#41B883', '#9A9A9A', '#00D8FF', '#DD1B16']

  chartData: ChartData = {
    labels: ['Validées', 'En attente'],
    datasets: [
      {
        label: 'Réservations pour ce service',
        backgroundColor: this.chartBackgroundColor,
        data: [33, 9]
      }
    ]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      tooltip: {
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 16
        },
        footerFont: {
          size: 14
        },
        boxPadding: 10,
        padding: 12,
      },
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          font: {
            size: 16
          },
          padding: 18
        }
      }
    }
  };


  bookingStats: CompleteStats | null = null;

  totalBooking = 0

  validBookings = 0

  pendingBookings = 0

  mounted() {
    this.handleChartData()
  }

  handleChartData(){
    this.bookingStats = this.bookingStatistics;
    const periodStat = this.getPeriodStats(this.selectedStatPeriod)

    // selection des statistiques à afficher selon la valeur du select dans le composant bookingStats
    const periodBookingsStats = this.bookingStats[periodStat].p1

    // selection des statistiques à afficher selon la valeur du Service dans le composant bookingStats
    const slotFilteredBookingStats = periodBookingsStats.find(slot => slot.slotIndex === this.selectedSlotIndex)

    if (slotFilteredBookingStats) {
      this.totalBooking = slotFilteredBookingStats?.totalBooking;
      this.validBookings = slotFilteredBookingStats?.validBooking;
      this.pendingBookings = (this.totalBooking && this.validBookings) ? this.totalBooking - this.validBookings : 0;

      this.chartData = this.setChartData([this.validBookings, this.pendingBookings])
    }
  }

  setChartData(data: number[], labels?: string[], backgroundColor?: string[], label?: string) {
    const chartLabels = labels ?? this.chartData.labels
    const bgColor = backgroundColor ?? this.chartBackgroundColor
    const datasetLabel = label ?? 'dataset'

    return {
      labels: chartLabels,
      datasets: [
        {
          label: datasetLabel,
          backgroundColor: bgColor,
          data,
        }
      ]
    };
  }

  getPeriodStats(selectedStatPeriod: string) {
    switch (selectedStatPeriod) {
      case "Aujourd'hui":
        return 'today'
      case "Hier":
        return 'yesterday'
      case 'Cette semaine':
        return 'week'
      case 'Ce mois':
        return 'month'
      case 'Cette année':
        return 'year'
      default:
        return 'today'
    }
  }
}

